interface FooterProps {
  language: 'de' | 'ru';
}

export default function Footer({ language }: FooterProps) {
  const content = {
    de: {
      brand: 'Peters Klangwelt',
      description: 'Romantik, Philosophie & Heimat in Wort und Bild',
      addressTitle: 'ADRESSE',
      address: 'Musikstraße 70\n12345 Berlin\nDeutschland',
      phoneTitle: 'TELEFON',
      phone: '+49 (0) 123 456789',
      emailTitle: 'E-MAIL',
      email: 'kontakt@petersklangwelt.de',
      copyright: '© 2025 Peters Klangwelt. Alle Rechte vorbehalten.',
      links: ['Impressum', 'Datenschutz', 'AGB'],
      poweredBy: 'Website Builder'
    },
    ru: {
      brand: 'Мир Питера',
      description: 'Романтика, философия и родина в слове и образе',
      addressTitle: 'АДРЕС',
      address: 'Музыкальная улица 70\n12345 Берлин\nГермания',
      phoneTitle: 'ТЕЛЕФОН',
      phone: '+49 (0) 123 456789',
      emailTitle: 'ЭЛЕКТРОННАЯ ПОЧТА',
      email: 'kontakt@petersklangwelt.de',
      copyright: '© 2025 Мир Питера. Все права защищены.',
      links: ['Выходные данные', 'Конфиденциальность', 'Условия'],
      poweredBy: 'Website Builder'
    }
  };

  const t = content[language];

  return (
    <footer className="bg-[#2c1810] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Left Column - Brand */}
          <div>
            <h3 className="font-serif text-4xl font-bold mb-4">
              {t.brand}
            </h3>
            <p className="font-serif text-base text-white/80 mb-6">
              {t.description}
            </p>
            
            {/* Social Icons */}
            <div className="flex space-x-4">
              <a href="#" className="w-12 h-12 rounded-full border-2 border-white/50 flex items-center justify-center hover:border-[#C5B358] hover:bg-[#C5B358]/10 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 rounded-full border-2 border-white/50 flex items-center justify-center hover:border-[#C5B358] hover:bg-[#C5B358]/10 transition-all cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 rounded-full border-2 border-white/50 flex items-center justify-center hover:border-[#C5B358] hover:bg-[#C5B358]/10 transition-all cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 rounded-full border-2 border-white/50 flex items-center justify-center hover:border-[#C5B358] hover:bg-[#C5B358]/10 transition-all cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Contact Info */}
          <div className="grid grid-cols-1 gap-8">
            <div>
              <h4 className="font-serif text-sm font-bold text-[#C5B358] mb-3 tracking-wider">
                {t.addressTitle}
              </h4>
              <p className="font-serif text-base text-white/90 whitespace-pre-line">
                {t.address}
              </p>
            </div>
            
            <div>
              <h4 className="font-serif text-sm font-bold text-[#C5B358] mb-3 tracking-wider">
                {t.phoneTitle}
              </h4>
              <p className="font-serif text-base text-white/90">
                {t.phone}
              </p>
            </div>
            
            <div>
              <h4 className="font-serif text-sm font-bold text-[#C5B358] mb-3 tracking-wider">
                {t.emailTitle}
              </h4>
              <p className="font-serif text-base text-white/90">
                {t.email}
              </p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="flex justify-center md:justify-end">
            <div className="w-64 h-80 rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/cad9cc0f1821ed2154e23a8fbbde16e1.jpg"
                alt="Footer Image"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-[#C5B358]/30">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="font-serif text-sm text-white/70">
            {t.copyright}
          </p>
          
          <div className="flex items-center space-x-6">
            {t.links.map((link, index) => (
              <a
                key={index}
                href="#"
                className="font-serif text-sm text-white/70 hover:text-[#C5B358] transition-colors cursor-pointer whitespace-nowrap"
              >
                {link}
              </a>
            ))}
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="font-serif text-sm text-white/70 hover:text-[#C5B358] transition-colors cursor-pointer whitespace-nowrap"
            >
              {t.poweredBy}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
